import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';
import { AlertCircle } from 'lucide-react';

export function SignInPage() {
  const { signIn } = useAuth();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-8">
        {error && (
          <div className="rounded-xl border border-destructive/50 bg-destructive/10 p-4 flex gap-3">
            <AlertCircle className="h-5 w-5 flex-shrink-0 text-destructive" />
            <div className="text-sm">
              <p className="font-medium text-destructive">Sign-in failed</p>
              <p className="text-muted-foreground mt-0.5">
                {errorDescription || error}
              </p>
              <Link to="/signin" className="text-primary text-xs font-medium mt-2 inline-block">
                Try again
              </Link>
            </div>
          </div>
        )}
        <div className="text-center">
          <Link to="/" className="inline-flex items-center gap-2 mb-8">
            <img
              src="/eventtools-logo.svg"
              alt="Event.Tools"
              className="h-10 w-auto"
            />
            <span className="text-xl font-semibold text-foreground">
              Event.Tools
            </span>
          </Link>
          <h1 className="text-2xl font-bold text-foreground">Sign in</h1>
          <p className="mt-2 text-muted-foreground">
            Sign in with Google to get started.
          </p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => void signIn()}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-xl border border-border bg-card hover:bg-muted/50 text-foreground font-medium transition-colors"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Sign in with Google
          </button>
        </div>

        <p className="text-center text-sm text-muted-foreground">
          <Link to="/" className="hover:text-foreground transition-colors">
            &larr; Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}
